import React from 'react';
import './preview-steps.sass';
import StepOne from '../../assets/preview/Step_one.png';
import StepOneMobile from '../../assets/preview/Step_one_mobile.png';
import StepOneMdm from '../../assets/preview/Step_one_mdm.png';
import StepTwo from '../../assets/preview/Step_two.png';
import StepTwoMobile from '../../assets/preview/Step_two_mobile.png';
import StepTwoMdm from '../../assets/preview/Step_two_mdm.png';
import StepThree from '../../assets/preview/Step_three.png';
import StepThreeMobile from '../../assets/preview/Step_three_mobile.png';
import StepThreeMdm from '../../assets/preview/Step_three_mdm.png';

export const PreviewSteps = () => {
    return (
      <div className='vv-preview-steps'>
          <div className='vv-preview-steps__left-container'>
              <div className='vv-preview-step vv-preview-step--one'>
                  <h2>1</h2>
                  <div className='vv-preview-step__one-column'>
                      <h3>Aplikacja bez rejestracji</h3>
                      <p>pobierz i korzystaj od razu!</p>
                  </div>
              </div>
              <div className='vv-preview-steps-arrows vv-preview-steps-arrows--one'>
                  <picture>
                      <source media='(min-width: 1250px)' srcSet={StepOne}/>
                      <source media='(min-width: 920px)' srcSet={StepOneMdm}/>
                      <img src={StepOneMobile} alt='Arrows'/>
                  </picture>
              </div>
              <div className='vv-preview-step vv-preview-step--two'>
                  <h2>2</h2>
                  <div className='vv-preview-step__two-column'>
                      <h3>Wydarzenia w jednym miejscu</h3>
                      <p>Kulturalne i sportowe eventy, top restauracje, bary i usługi, których szukasz.</p>
                  </div>
              </div>
          </div>
          <div className='vv-preview-steps__right-container'>
              <div className='vv-preview-steps-arrows vv-preview-steps-arrows--two'>
                  <picture>
                      <source media='(min-width: 1250px)' srcSet={StepTwo}/>
                      <source media='(min-width: 920px)' srcSet={StepTwoMdm}/>
                      <img src={StepTwoMobile} alt='Arrows'/>
                  </picture>
              </div>
              <div className='vv-preview-step vv-preview-step--three'>
                  <h2>3</h2>
                  <div className='vv-preview-step__three-column'>
                      <h3>Zniżki do -25% dla Ciebie</h3>
                      <p>Do TOP-owych miejsc w Twoim mieście i nie tylko! Korzystaj z nich dowolną ilość razy!</p>
                  </div>
              </div>
              <div className='vv-preview-steps-arrows vv-preview-steps-arrows--three'>
                  <picture>
                      <source media='(min-width: 1250px)' srcSet={StepThree}/>
                      <source media='(min-width: 920px)' srcSet={StepThreeMdm}/>
                      <img src={StepThreeMobile} alt='Arrows'/>
                  </picture>
              </div>
              <div className='vv-preview-step vv-preview-step--four'>
                  <h2>4</h2>
                  <div className='vv-preview-step__four-column'>
                      <h3>Dodaj bilet z dowolnego wydarzenia…</h3>
                      <p>… i odbierz jeszcze więcej zniżek, które nigdy się nie kończą</p>
                  </div>
              </div>
          </div>
      </div>
    );
};
